<template lang="pug">
.header-property-card
  .property-information
    .reward-group(@click="goBountyRecord")
      .reward-label-row
        span.reward-label 我的奖励金
        .common-arrow-right
      .reward-amount {{ bountyLoaded ? displayPoints : '--' }}

    .equivalent-group
      .equivalent-label-row
        span.equivalent-label 可抵顺风车费
      .equivalent-amount-row
        span.equivalent-amount {{ bountyLoaded ? equivalentAmount : '--' }}
        span.equivalent-suffix {{ equivalentUnit }}

    .go-ride-btn(@click.stop="handleGoHitch")
      span.go-ride-text 去约车

  transition(:name="hasLoadedOnce ? 'collect' : ''" mode="out-in")
    .award-content(
      :key="hitchInfo.canReceived ? 'received' : 'empty'"
      :class="{ 'is-can-received': hitchInfo.canReceived, 'is-empty': !hitchInfo.canReceived }"
      @click="handleContentClick"
    )
      .can-received-row(v-if="hitchInfo.canReceived")
        img.title-img(:src="hitchInfo.mainTitle" alt="单单返车费")
        .bubble-row
          .bubble(
            v-for="(item, idx) in displayBubbles"
            :key="(item.taskCode || item.businessLine || '') + idx"
            :class="{ 'is-inactive': !item.active }"
            :style="bubbleStyles[idx]"
          )
            img.bubble-bg(
              src="https://m.hellobike.com/6737212e_bubble%20(1).png"
              alt="奖励气泡"
            )
            span.bubble-amount {{item.amount}}
            span.bubble-name {{ item.name }}

        .receive-btn
          .receive-btn-text 一键领取

      img.no-received-img(v-else :src="hitchInfo.noAwardImg" alt="")

  //- 单单返奖励引导弹窗
  AwardGuidePopup(
    :visible="awardGuidePopupVisible"
    :list="taskAwardList"
    :extInfo="taskAwardExtInfo"
    @close="handleAwardGuidePopupClose"
  )
</template>

<script>
import Loading from '@/components/loading';
import eventBus from '@/const/eventBus';
import { jumpUrl } from '@/utils/tools';
import config from '@/const/config';
import { Storage } from '@/utils/storage';
import { Navigator } from '@hb/h5-navigator';
import { getTaskAwardListData } from '../common/helper';
import AwardGuidePopup from '../new-version-cpns/award-guide-popup';
import { STORAGE_KEY_SHOW_HITCH_AWARD_GUIDE } from '../consts';

export default {
  name: 'HitchProperty',
  components: {
    AwardGuidePopup,
  },
  props: {
    // 奖励金数量
    points: {
      type: Number,
      default: 0,
    },
    // 奖励金等值金额
    bounty: {
      type: Number,
      default: 0,
    },
    bountyLoaded: {
      type: Boolean,
      default: false,
    },
    // 顺风车心智单单返数据
    hitchBonusData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      hasLoadedOnce: false,
      // 单单返奖励引导弹窗信息
      awardGuidePopupVisible: false,
      taskAwardList: [],
      taskAwardExtInfo: {},
    };
  },
  inject: {
    currentlyIsVip: { from: 'currentlyIsVip', default: () => () => false },
  },
  computed: {
    hitchInfo() {
      const d = this.hitchBonusData || {};
      return {
        mainTitle: d.mainTitle || '',
        noAwardImg: d.imageUrl || '',
        multipleIndicator: Number(d.multipleIndicator) || 1,
        canReceived: d.canReceived || false,
        taskList: Array.isArray(d.taskCanReceiveAwardDTOList)
          ? d.taskCanReceiveAwardDTOList
          : [],
        btnJumpUrl: d.btnJumpUrl || '',
      };
    },
    displayBubbles() {
      return this.hitchInfo.taskList.map((item) => ({
        ...item,
        name: item.businessLine || '',
        amount: item.offerWorth || 0,
        active: item.status === 1,
      }));
    },
    // duration: 2.0 ~ 3.4s；delay: -2 ~ 0s，让各气泡相位错开
    bubbleStyles() {
      // 黄金比小数：叠加取模 → 均匀伪随机
      const GOLDEN_RATIO_FRAC = 0.618;
      const PHASE_OFFSET = 0.382;
      return this.displayBubbles.map((_, idx) => {
        const phaseDuration = (idx * GOLDEN_RATIO_FRAC) % 1;
        const phaseDelay = (idx * GOLDEN_RATIO_FRAC + PHASE_OFFSET) % 1;
        return {
          animationDuration: `${(2.0 + phaseDuration * 1.4).toFixed(2)}s`,
          animationDelay: `${(-phaseDelay * 2).toFixed(2)}s`,
        };
      });
    },
    // 奖励金总数
    displayPoints() {
      const v = Number(this.points) || 0;
      const s = String(v);
      return s.length >= 7 ? `${s.slice(0, 6)}..` : s;
    },
    // 抵扣金额合计
    equivalentTotal() {
      const base = Number(this.bounty) || 0;
      return base * this.hitchInfo.multipleIndicator;
    },
    // 抵扣金额
    equivalentAmount() {
      const total = this.equivalentTotal;
      const value = total >= 1000 ? total / 1000 : total;
      return parseFloat(value.toFixed(2)).toString();
    },
    // 抵扣金额单位
    equivalentUnit() {
      return this.equivalentTotal >= 1000 ? '千元' : '元';
    },
  },
  watch: {
    // 首次拿到接口数据后，下一帧再启用 transition，避免空态切到可领取态时播入场动画
    hitchBonusData() {
      if (!this.hasLoadedOnce) {
        this.$nextTick(() => {
          this.hasLoadedOnce = true;
        });
      }
    },
  },
  created() {
    eventBus.$on('showAwardGuidePopup', this.showAwardGuidePopup);
  },
  beforeDestroy() {
    eventBus.$off('showAwardGuidePopup', this.showAwardGuidePopup);
  },
  methods: {
    handleContentClick() {
      if (this.hitchInfo.canReceived) {
        this.$emit('click-receive');
      } else {
        // 无奖励金状态,点击拉起单单返奖励引导弹窗
        this.getTaskAwardList();
      }
    },
    // 展示单单返引导弹窗（领取后自动弹）：永久仅展示一次
    showAwardGuidePopup() {
      const awardGuide = Storage.getItem(STORAGE_KEY_SHOW_HITCH_AWARD_GUIDE);
      if (awardGuide !== 'YES') {
        this.getTaskAwardList();
      }
      Storage.setItem(STORAGE_KEY_SHOW_HITCH_AWARD_GUIDE, 'YES');
    },
    // 获取单单返任务奖励列表
    async getTaskAwardList() {
      Loading.show();
      try {
        const { taskAwardList, ariesData } = await getTaskAwardListData({
          isVip: this.currentlyIsVip(),
        });
        if (taskAwardList.length !== 0) {
          this.taskAwardList = taskAwardList;
          this.taskAwardExtInfo = ariesData;
          this.awardGuidePopupVisible = true;
        }
      } finally {
        Loading.close();
      }
    },
    handleAwardGuidePopupClose() {
      this.awardGuidePopupVisible = false;
    },
    goBountyRecord() {
      jumpUrl(
        `https://m.hellobike.com/AppPlatformH5/${
          config.env !== 'pro' ? `${config.env}/` : ''
        }latest/index.html#/bounty/exchange?adsource=1`,
      );
    },
    handleGoHitch() {
      const url = this.hitchInfo.btnJumpUrl;
      if (!url) return;
      Navigator.go(url);
    },
  },
};
</script>

<style lang="less" scoped>
.header-property-card {
  position: relative;
  margin: 0 0.12rem;

  .property-information {
    position: relative;
    z-index: 2;
    display: flex;
    align-items: center;
    padding: 0.2rem;
    padding-right: 0.12rem;
    background: linear-gradient(275.55deg, #ffcf00 13.63%, #ffde38 95.47%);
    border-radius: 0.16rem;

    .reward-group {
      flex: 1;
      min-width: 0;
      display: flex;
      flex-direction: column;
      gap: 0.05rem;

      .reward-label-row {
        display: flex;
        align-items: center;
        opacity: 0.7;
        height: 0.12rem;

        .reward-label {
          font-family: 'PingFang SC', sans-serif;
          font-weight: 400;
          font-size: 0.12rem;
          color: #000;
        }

        .common-arrow-right {
          border-color: #000;
          margin-top: 0.02rem;
          margin-left: -0.02rem;
        }
      }

      .reward-amount {
        font-family: 'DIN', 'DIN Alternate', sans-serif;
        font-weight: 700;
        font-size: 0.28rem;
        height: 0.34rem;
        line-height: 0.34rem;
        color: #000;
      }
    }

    .equivalent-group {
      flex: 1;
      min-width: 0;
      display: flex;
      flex-direction: column;
      gap: 0.05rem;
      margin-left: 0.33rem;

      .equivalent-label-row {
        display: flex;
        align-items: center;
        height: 0.12rem;
        opacity: 0.7;

        .equivalent-label {
          font-family: 'PingFang SC', sans-serif;
          font-weight: 400;
          font-size: 0.12rem;
          color: #000;
        }
      }

      .equivalent-amount-row {
        display: flex;
        align-items: baseline;
        height: 0.34rem;
        line-height: 0.34rem;

        .equivalent-amount {
          font-family: 'DIN', 'DIN Alternate', sans-serif;
          font-weight: 700;
          font-size: 0.28rem;
          height: 0.34rem;
          line-height: 0.34rem;
          color: #000;
        }

        .equivalent-suffix {
          font-family: 'PingFang SC', sans-serif;
          font-weight: 400;
          font-size: 0.12rem;
          color: #000;
          margin-left: 0.02rem;
          flex-shrink: 0;
        }
      }
    }

    .go-ride-btn {
      flex: 0 0 auto;
      align-self: flex-end;
      padding: 0.06rem 0.16rem;
      background: #fff8d9;
      border-radius: 1rem;
      display: flex;
      align-items: center;
      justify-content: center;

      .go-ride-text {
        font-family: 'PingFang SC', sans-serif;
        font-weight: 500;
        font-size: 0.12rem;
        line-height: 1.5em;
        color: #000;
      }
    }
  }

  .award-content {
    position: relative;
    z-index: 1;
    background: #fff;
    border-radius: 0 0 0.16rem 0.16rem;
    margin-top: -0.16rem;

    &.is-empty {
      min-height: 0.42rem;
      overflow: hidden;
    }

    .can-received-row {
      display: flex;
      height: 0.85rem;
      padding: 0.26rem 0.03rem 0.07rem 0.12rem;

      .title-img {
        width: 0.5rem;
        height: 0.45rem;
        margin-right: 0.08rem;
        object-fit: contain;
      }

      .bubble-row {
        flex: 1;
        display: flex;
        align-items: center;
        gap: 0.08rem;
        overflow-x: auto;
        overflow-y: hidden;

        &::-webkit-scrollbar {
          display: none;
        }

        .bubble {
          position: relative;
          flex: 0 0 0.48rem;
          width: 0.48rem;
          height: 0.48rem;
          animation: bubble-float 2s ease-in-out infinite;

          &.is-inactive {
            opacity: 0.3;
          }

          .bubble-bg {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            object-fit: contain;
            z-index: 1;
            pointer-events: none;
          }

          .bubble-name {
            position: absolute;
            left: 0;
            top: 0.25rem;
            width: 0.48rem;
            font-family: 'PingFang SC', sans-serif;
            font-weight: 400;
            font-size: 0.0745rem;
            color: #7f3200;
            text-align: center;
            z-index: 2;
          }

          .bubble-amount {
            position: absolute;
            left: 0;
            top: 0.07rem;
            width: 0.48rem;
            font-family: 'DIN Alternate', 'DIN', sans-serif;
            font-weight: 700;
            font-size: 0.165rem;
            color: #662800;
            text-align: center;
            z-index: 2;
          }
        }
      }

      .receive-btn {
        position: relative;
        width: 0.8rem;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #fff;
        z-index: 3;

        .receive-btn-text {
          height: 0.28rem;
          line-height: 0.28rem;
          padding: 0 0.07rem;
          font-family: 'PingFang SC', sans-serif;
          font-weight: 500;
          font-size: 0.12rem;
          color: #000;
          background: #ffe888;
          border-radius: 1rem;
        }
      }
    }

    .no-received-img {
      display: block;
      width: 100%;
      height: auto;
    }
  }
}

@keyframes bubble-float {
  0%,
  100% {
    transform: translateY(0.025rem);
  }

  50% {
    transform: translateY(-0.025rem);
  }
}

// 领取后：整个白色资产卡片向上收缩至一个点并淡出，再淡入展示无奖励金样式
.collect-leave-active {
  transform-origin: top center;
  transition:
    transform 0.52s cubic-bezier(0.55, 0, 0.55, 0.2),
    opacity 0.45s ease-out;
  pointer-events: none;
}

.collect-leave-to {
  transform: scale(0);
  opacity: 0;
}

.collect-enter-active {
  transition: opacity 0.32s ease-out;
}

.collect-enter {
  opacity: 0;
}
</style>
